import EventEmitter from 'events';

export default function AnimatedNumber(initial = 0, resolution = 0.01) {
  this.tendTo = initial;
  this.initialValue = initial;

  let lastValue = initial;

  const animate = () => {
    let nextValue = lastValue * 0.9 + this.tendTo * 0.1;

    if (nextValue < resolution * 20) {
      nextValue = lastValue * 0.8 + this.tendTo * 0.2;
    }

    if (nextValue < resolution) {
      this.emit('change', this.initialValue);
      lastValue = this.initialValue;
    } else if (Math.abs(nextValue - lastValue) > resolution || nextValue < resolution * 10) {
      this.emit('change', Math.round(nextValue / resolution) * resolution);
      lastValue = nextValue;
    }

    requestAnimationFrame(animate);
  };

  requestAnimationFrame(animate);
}

AnimatedNumber.prototype = Object.create(EventEmitter.prototype);

AnimatedNumber.prototype.set = function setNumber(newNumber) {
  this.tendTo = newNumber;
};

AnimatedNumber.prototype.reset = function resetNumber() {
  this.tendTo = this.initialValue;
};



// WEBPACK FOOTER //
// ./src/js/lib/animator.js